import platform from '@propertypal/shared/src/utils/platform';
import styled from 'styled-components';

export const Container = styled.div`
  background-color: ${(props) => props.theme.backgroundLightest};
  padding: 15px;
  border-radius: 8px;
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  color: ${(props) => props.theme.textDark};

  h4 {
    font-size: 16px;

    span {
      font-weight: normal;
      display: block;
    }
  }

  ${({ theme }) =>
    platform.type === 'propertypal' &&
    `
    background-color: ${theme.white};
    border-radius: 50px;
    border: 1px solid ${theme.keyline};
    padding: 15px 25px;
    align-self: flex-start;
  `}
`;

export default Container;
